import {Component, ViewEncapsulation, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AppService} from '@irb/app.service';
import {IrbClientsService} from '@irb/irb-clients/irb-clients.service';
import {IrbClientsEvents, IrbAppEvents, IrbEditorsEvents} from '@irb-common/events';
import {IrbEditorsService} from '@irb/irb-editors/irb-editors.service';

@Component({ standalone: false,
    selector: 'irb-import-loss-priority-settings-dialog',
    templateUrl: './import-loss-priority-settings-dialog.component.html',
    styleUrls: ['./import-loss-priority-settings-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportLossPrioritySettingsDialogComponent implements OnInit {
    file: any;
    hasFile: boolean = false;
    isValidFile: boolean = false;
    errorMessage: string;
    lossPriorityValues: any = {
        ST: 'Use Short Term losses only to meet the target',
        ST_ONLY: 'Use Short Term losses only to meet the target',
        LT: 'Use Long Term losses only to meet the target',
        LT_ONLY: 'Use Long Term losses only to meet the target',
        STLT: 'Use Short, then long term losses to meet the target',
        ST_LT: 'Use Short, then long term losses to meet the target',
        LARGESTLOSS: 'Use all losses, prioritizing from the largest $ loss first to minimize trades',
        LARGEST_LOSS: 'Use all losses, prioritizing from the largest $ loss first to minimize trades',
    };

    constructor(
        public dialogRef: MatDialogRef<ImportLossPrioritySettingsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public analysisId: number,
        public as: AppService,
        public cs: IrbClientsService,
        private ies: IrbEditorsService,
    ) {
    }

    ngOnInit() {
    }

    close() {
        this.dialogRef.close();
    }

    onFileChange(event: any) {
        this.file = event.target.files[0];
        this.hasFile = true;
        this.isValidFile = this.file.name.endsWith('.csv');
    }
    

    submitFile() {
        const f = new FormData();
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        f.append('ImportLossTarget0', this.file, this.file.name);
      
        this.ies.getImportTaxLossSettings(f,this.analysisId).subscribe({
            next: (res: string) => {
                const response = JSON.parse(res.substring(res.indexOf('<textarea>') + 10, res.indexOf('</textarea>')));
                // console.log(response);
                if (!response || (response.validRecords === undefined || response.invalidRecords === undefined)) {
                    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                        severity: 'error',
                        summary: 'Import Loss Priority Settings',
                        detail: 'An error occurred processing your request.'
                    });
                    this.close();
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                    return;
                } else if (response.validRecords.length === 0 && response.invalidRecords.length === 0) {
                    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                        severity: 'warn',
                        summary: 'Import Loss Priority Settings',
                        detail: 'No portfolios had Loss Target settings imported.'
                    });
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                    this.close();
                } else if (response.invalidRecords.length > 0) {
                    response.analysisId = this.analysisId;
                    // throw the dialog for invalid Records grid and pass the response object.
                    this.as.fireEvent(IrbEditorsEvents.SHOW_IMPORT_LOSS_PRIORITY_SETTINGS_ERROR_DIALOG,response);
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                    this.close();
                } else if (response.validRecords.length > 0) {
                    //directly call the valid records call. with valid records here.
                    this.ies.importValidLossTargetSettings(response.validRecords,this.analysisId).subscribe((responseObj: any) => {
                        let totalImportCount =0;

                        const validLossTargetResponse = JSON.parse(responseObj);
                        if (validLossTargetResponse && validLossTargetResponse.responseData !== undefined
                            && validLossTargetResponse.responseData.analysisPortDtoList !== undefined) {
                            validLossTargetResponse.responseData.analysisPortDtoList.map((portfolio: any) => {
                                portfolio.lossPrty = (portfolio.lossPrty === "" ?
                                    this.mapLossPriority("LARGESTLOSS") :
                                    this.mapLossPriority(portfolio.lossPrty));

                            });
                            let totalImported = validLossTargetResponse.responseData.analysisPortDtoList.filter((x:any)=>x.isImported);
                            if(totalImported && totalImported.length > 0) {
                                totalImportCount = totalImported.length;
                            }
                            this.as.fireEvent(IrbEditorsEvents.REFRESH_LOSS_PRIORITY_GRID, validLossTargetResponse);
                            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                                severity: 'success',
                                summary: totalImportCount + ' portfolios had Loss Target settings imported.'
                            });
                        } else {
                            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                                severity: 'warn',
                                summary: 'Import Loss Priority Settings',
                                detail: 'No portfolios had Loss Target settings imported.'
                            });
                        }
                    }, () => {
                    }, () => {
                        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                        this.close();
                    });
                }
            }, error: () => {
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            }
        });
    }

    mapLossPriority(lossPrty: string) {
        if (lossPrty) {
            let key = lossPrty.toUpperCase();
            return this.lossPriorityValues[key];
        } else {
            return lossPrty;
        }
    }
}
